import token, { tokenToVars } from '../token';
import Form from './form';

export { Form };
export default tokenToVars(Form, token);
